import moment from 'moment';
import DateUtils from '@spothero/utils/date';
import FETimeUtils from '@spothero/utils/time';

/**
 * Utilities for working with times.
 * @module TimeUtils
 */
const TimeUtils = {
    /**
     * Check if time is more than 30 minutes in the past and return updated time if not.
     * @static
     * @function checkStaleStart
     * @param {Moment} starts - The start date/time as a moment instance.
     * @param {Moment} currentCityDateTime - The current date/time in the target city as a moment instance.
     * @param {String} currentCityTimezone - The target city timezone string value i.e. "America/New_York".
     * @example
     * const {
     *     newStart,
     *     isNewStart
     * } = TimeUtils.checkStaleStart(moment(), window.currentCityDateTime, 'America/New_York');
     * @returns {Object} - Returns the newStart (a moment instance) and a boolean isNewStart.
     */
    checkStaleStart(starts, currentCityDateTime, currentCityTimezone) {
        let newStart = starts;
        let isNewStart = false;

        if (!currentCityTimezone) {
            currentCityTimezone = DateUtils.getTimeZone();
        }

        // create moment if not already a moment
        if (!moment.isMoment(newStart)) {
            newStart = moment(starts, moment.ISO_8601);
        }

        // bk (7/2016) okay this shit is crazy but here is what happens
        // - both nowLocalized and newStart are both timezone unaware moment objects
        // - when we add the tz currentCityTimezone to nowLocalized it resolves to the same time in the new timezone
        // - when we add the tz currentCityTimezone to newStart it resolves to the timezone adjusted time in the new timezone
        // - in order to normalize the two and maintain the proper timezone i subtract the difference in minutes between the system and currentCityTimezone timezones
        // - we then determine if the request start is before the local current time
        // - if the time is stale we then determine if the local time is before or after the 30 minute mark to determine if we should round up or down to the nearest half hour to ensure its inclusive of the current time
        let nowLocalized = (currentCityDateTime) ? moment(currentCityDateTime) : moment();
        const startDateLocalized = newStart.tz(currentCityTimezone).add(nowLocalized.utcOffset() - newStart.utcOffset(), 'minutes');

        nowLocalized = nowLocalized.tz(currentCityTimezone);

        if (startDateLocalized.isBefore(nowLocalized.clone().subtract(30, 'minutes'))) {
            const nowMinute = nowLocalized.minute();

            if (nowMinute > 30) {
                newStart = nowLocalized.add((30 - nowMinute) % 30, 'minutes');
            } else {
                newStart = nowLocalized.subtract(nowMinute, 'minutes');
            }

            isNewStart = true;
        }

        return {
            isNewStart,
            newStart
        };
    }
};

export default {
    ...FETimeUtils,
    ...TimeUtils
};



// WEBPACK FOOTER //
// ./frontend/src/js/utils/time.js